var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.8945H7V10.8945H9V17.8945ZM13 17.8945H11V7.89453H13V17.8945ZM17 17.8945H15V13.8945H17V17.8945ZM19 19.8945H5V5.89453H19V19.9945M19 3.89453H5C3.9 3.89453 3 4.79453 3 5.89453V19.8945C3 20.9945 3.9 21.8945 5 21.8945H19C20.1 21.8945 21 20.9945 21 19.8945V5.89453C21 4.79453 20.1 3.89453 19 3.89453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.664a2b49e14d8de87988f5c43834f10b.svg";
export { ForwardRef as ReactComponent };